import _typeof from '@babel/runtime/helpers/typeof';
import * as React from 'react';

/*
  This function is used to combine multiple refs into a single ref.
  Especially useful when you want to combine a forwardRef with a
  ref created within the component.
*/
function useCombinedRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return React.useCallback(function (element) {
    for (var i = 0; i < refs.length; i++) {
      var ref = refs[i];
      // checking whether the ref is a forwardRef
      if (typeof ref === 'function') ref(element);
      // checking whether the ref has a mutable current property
      else if (ref && _typeof(ref) === 'object') ref.current = element;
    }
  }, refs);
}

export { useCombinedRef };
